module.exports = __webpack_public_path__ + "img/Intel64_128.502bc871.png";